import { render, staticRenderFns } from "./groupOrder.vue?vue&type=template&id=119ddfe2&"
import script from "./groupOrder.vue?vue&type=script&lang=js&"
export * from "./groupOrder.vue?vue&type=script&lang=js&"
import style0 from "./groupOrder.vue?vue&type=style&index=0&id=119ddfe2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports